// @flow
export const AppsToCCXUICategoryMaping = {
	design: 'design',
	photography: 'photography',
	'video-audio': 'video-audio',
	illustration: 'illustration',
	'ux-web': 'ux-web',
	all: 'all',
	'your-apps':'all',
	starter: 'all',
	ar: 'ar',
	'social-media': 'social-media',
	'acrobat-pdf': 'acrobat-pdf'
};

export const DownloadWorkflow = {
	Incompatible : 'Incompatible',
	Kaizen : 'Kaizen',
	KaizenOldVersion : 'Kaizen-Old-Version',
	Thor : 'Thor',
	ThorOldVersion : 'Thor-Old-Version',
	ErrorFFCFetchFail: 'Error-FFC-Fetch_Fail',
	ErrorFFCDataEmpty: 'Error-FFC-Data-Empty',
	FileOpen: 'File-Open'
};

export const campaignId: {[x: string]: string} = {
	dummyTest: 'dummyTest',
	growthIntentSelection: '2019-09-IntentSelection',
	growthIntentSelectionPhotoshop: '2019-12-IntentSelection-nonTWP',
	nujM3Test: '2020-12-NUJ-M3',
	nujM3PhotoPlanTest: '2020-12-NUJ-M3-Photo',
	nujM3AllAppsTest: '2020-08-NUJ-M3-AllApps',
	throughlineV3En: '2020-04-IntentSelection-PS-TWP',
	throughlineV3Ja: '2020-04-IntentSelection-PS-CCPP-JA',
	categoryPageRevampTest: '2020-08-CategoryPage-Revamp',
	bannerOnMobile: '2021-1-BannerOnMobile',
	kaizenInstallerWaitTime: '2021-03-KaizenInstallerWaitTime',
	trialToTWPFree: '2021-05-TrialToTWP-Free',
	trialToTWPPaid: '2021-05-TrialToTWP-Paid'
};

export const twpSapcodes = ['AEFT', 'FRSC', 'ILST', 'IDSN', 'LRCC', 'LTRM', 'PHSP', 'PPRO', 'RUSH'];

export const stockUrlParams = {
	apps: encodeURIComponent('App Card'),
	pdp: 'PDP',
	resources: 'Resources',
	banner: 'Banner'
};

export const CCWebRevampCategoryList = ['design','photography','video-audio','illustration','ux-web','all', 'acrobat-pdf', 'ar', 'social-media', 'updates'];

export const subCategoryList = ['desktop', 'mobile', 'web'];

// Map of url Paths and IDs for Title string
// Key corresponds to the Url path under Apps section
// Value corresponds to the string ID under translations
export const pathTitleMap = {
	'your-apps': 'apps.title.yourapps',
	all: 'apps.title.allapps',
	design: 'apps.comparison.graphicdesign',
	photography: 'apps.comparison.photography',
	'video-audio': 'apps.comparison.videoaudio',
	'ux-web': 'apps.comparison.ui-ux',
	illustration: 'apps.comparison.illustration',
	comparison: 'apps.title.compare.small',
	'acrobat-pdf': 'apps.title.acrobat-pdf',
	ar: 'apps.title.ar',
	'social-media': 'apps.title.social-media',
	updates: 'apps.title.updates'
};

/*
** Map of productId's to be used for redirection for rebranding
** Key corresponds to the old productId
** Value corresponds to an object which contains the new productId,
** and the flags whose presence and abscnece would enable redirection
*/
export const productIdMap: {[x: string]: Object} = {
	'substance3d-sampler': {
		newProductId: 'substance-alchemist',
		featureFlagPresent: '',
		featureFlagAbsent: '',
	},
	'substance3d-assets': {
		newProductId: 'substance-web',
		featureFlagPresent: '',
		featureFlagAbsent: '',
	},
	'premiere-express': {
		newProductId: 'premiere-rush',
		featureFlagPresent: '',
		featureFlagAbsent: '',
	},

	'substance-painter': {
		newProductId: 'substance3d-painter',
		featureFlagPresent: '',
		featureFlagAbsent: '',
	},
	'substance-designer': {
		newProductId: 'substance3d-designer',
		featureFlagPresent: '',
		featureFlagAbsent: '',
	},
	'typekit-web': {
		newProductId: 'adobe-fonts',
		featureFlagPresent: '',
		featureFlagAbsent: '',
	},

	'spark-web': {
		newProductId: 'express-web',
		featureFlagPresent: 'temp_cch_11689',
		featureFlagAbsent: '',
	},
	'express-web': {
		newProductId: 'spark-web',
		featureFlagPresent: '',
		featureFlagAbsent: 'temp_cch_11689',
	},

	'spark-post-mobile': {
		newProductId: 'express-mobile',
		featureFlagPresent: 'temp_cch_11689',
		featureFlagAbsent: '',
	},
	'express-mobile': {
		newProductId: 'spark-post-mobile',
		featureFlagPresent: '',
		featureFlagAbsent: 'temp_cch_11689',
	},

	'rush-mobile': {
		newProductId: 'premiere-express-mobile',
		featureFlagPresent: 'temp_cch_11689',
		featureFlagAbsent: '',
	},
	'premiere-express-mobile': {
		newProductId: 'rush-mobile',
		featureFlagPresent: '',
		featureFlagAbsent: 'temp_cch_11689',
	}
};

/* eslint-disable camelcase */
// for new ccweb design
export const sapCodeToProductMetaData = {
	RUSH: {
		platform: 'desktop',
		productId: 'premiere-rush'
	},
	PHSP: {
		platform: 'desktop',
		productId: 'photoshop'
	},
	ILST: {
		platform: 'desktop',
		productId: 'illustrator'
	},
	IDSN: {
		platform: 'desktop',
		productId: 'indesign'
	},
	SPRK: {
		platform: 'desktop',
		productId: 'xd'
	},
	PPRO: {
		platform: 'desktop',
		productId: 'premiere'
	},
	AEFT: {
		platform: 'desktop',
		productId: 'aftereffects'
	},
	ESHR: {
		platform: 'desktop',
		productId: 'dimension'
	},
	LRCC: {
		platform: 'desktop',
		productId: 'lightroom'
	},
	LTRM: {
		platform: 'desktop',
		productId: 'lightroom-classic'
	},
	APRO: {
		platform: 'desktop',
		productId: 'acrobat'
	},
	DRWV: {
		platform: 'desktop',
		productId: 'dreamweaver'
	},
	MUSE: {
		platform: 'desktop',
		productId: 'muse'
	},
	FLPR: {
		platform: 'desktop',
		productId: 'animate'
	},
	CHAR: {
		platform: 'desktop',
		productId: 'character-animator'
	},
	AUDT: {
		platform: 'desktop',
		productId: 'audition'
	},
	KBRG: {
		platform: 'desktop',
		productId: 'bridge'
	},
	AME: {
		platform: 'desktop',
		productId: 'media-encoder'
	},
	AICY: {
		platform: 'desktop',
		productId: 'incopy'
	},
	PRLD: {
		platform: 'desktop',
		productId: 'prelude'
	},
	FUSE: {
		platform: 'desktop',
		productId: 'fuse'
	},
	KCCC: {
		platform: 'desktop',
		productId: 'creative-cloud'
	},
	FRSC: {
		platform: 'desktop',
		productId: 'fresco-desktop'
	},
	SBSTP: {
		platform: 'desktop',
		productId: 'substance3d-painter'
	},
	SBSTA: {
		platform: 'desktop',
		productId: 'substance-alchemist'
	},
	SBSTD: {
		platform: 'desktop',
		productId: 'substance3d-designer'
	},
	STGR: {
		platform: 'desktop',
		productId: 'substance3d-stager'
	},
	FFC_SBSTSHARE: {
		platform: 'web',
		productId: 'substance3d-community-assets'
	},
	AERO: {
		platform: 'desktop',
		productId: 'aero'
	},
	PSXUWP: {
		platform: 'desktop',
		productId: 'photoshop-express-desktop'
	},
	FFC_CCXPOST: {
		platform: 'desktop',
		productId: 'express-mobile'
	},
	FFC_CCEXPRESS: {
		platform: 'desktop',
		productId: 'express-web'
	},
	FFC_BEHANCE: {
		platform: 'web',
		productId: 'behance-web'
	},
	FFC_LIGHTROOMWEB: {
		platform: 'web',
		productId: 'lightroom-web'
	},
	FFC_PORTFOLIO: {
		platform: 'web',
		productId: 'portfolio-web'
	},
	FFC_COLOR: {
		platform: 'web',
		productId: 'color-web'
	},
	'FFC-SPRK': {
		platform: 'web',
		productId: 'spark-web'
	},
	FFC_STOCK: {
		platform: 'web',
		productId: 'stock-web'
	},
	FFC_FONTS: {
		platform: 'web',
		productId: 'adobe-fonts'
	},
	FFC_LIVE: {
		platform: 'web',
		productId: 'adobe-live-web'
	},
	FFC_CAPTURE: {
		platform: 'mobile',
		productId: 'capture'
	},
	FFC_LIGHTROOM: {
		platform: 'mobile',
		productId: 'lightroom-mobile'
	},
	FFC_CCMOB: {
		platform: 'mobile',
		productId: 'cc-mobile'
	},
	FFC_XD: {
		platform: 'mobile',
		productId: 'xd-mobile'
	},
	FFC_SCAN: {
		platform: 'mobile',
		productId: 'scan-mobile'
	},
	FFC_ACROBAT: {
		platform: 'mobile',
		productId: 'acrobat-mobile'
	},
	FFC_DRAW: {
		platform: 'mobile',
		productId: 'illustrator-draw'
	},
	FFC_SKETCH: {
		platform: 'mobile',
		productId: 'photoshop-sketch'
	},
	FFC_MBEHANCE: {
		platform: 'mobile',
		productId: 'behance-mobile'
	},
	FFC_SPPAGE: {
		platform: 'mobile',
		productId: 'spark-page-mobile'
	},
	FFC_SPVIDEO: {
		platform: 'mobile',
		productId: 'spark-video-mobile'
	},
	FFC_PSEXP: {
		platform: 'mobile',
		productId: 'photoshop-express'
	},
	FFC_SPPOST: {
		platform: 'mobile',
		productId: 'spark-post-mobile'
	},
	FFC_PSFIX: {
		platform: 'mobile',
		productId: 'photoshop-fix'
	},
	FFC_RUSH: {
		platform: 'mobile',
		productId: 'rush-mobile'
	},
	FFC_PREXPR: {
		platform: 'mobile',
		productId: 'premiere-express-mobile'
	},
	FFC_COMP: {
		platform: 'mobile',
		productId: 'comp'
	},
	FFC_PSMIX: {
		platform: 'mobile',
		productId: 'photoshop-mix'
	},
	FFC_FRESCO: {
		platform: 'mobile',
		productId: 'fresco'
	},
	FFC_SBSTSOURCE: {
		platform: 'web',
		productId: 'substance-web'
	},
	FFC_MIXAMO: {
		platform: 'web',
		productId: 'mixamo-web'
	},
	FFC_AERO: {
		platform: 'mobile',
		productId: 'aero-mobile'
	},
	FFC_PHOTOSHOP: {
		platform: 'mobile',
		productId: 'photoshop-mobile'
	},
	FFC_FILLSIGN: {
		platform: 'mobile',
		productId: 'fill-sign'
	},
	FFC_DCWEB: {
		platform: 'web',
		productId: 'dc-web'
	},
	FFC_SIGN: {
		platform: 'web',
		productId: 'sign-web'
	},
	FFC_ILLUSTRATOR: {
		platform: 'mobile',
		productId: 'illustrator-mobile'
	},
	FFC_PHYLO: {
		platform: 'mobile',
		productId: 'photoshop-camera-mobile'
	}
};

// for new ccweb design
export const productIdToSapCode = {
	'premiere-rush': 'RUSH',
	photoshop: 'PHSP',
	illustrator: 'ILST',
	indesign: 'IDSN',
	xd: 'SPRK',
	premiere: 'PPRO',
	aftereffects: 'AEFT',
	dimension: 'ESHR',
	lightroom: 'LRCC',
	'lightroom-classic': 'LTRM',
	acrobat: 'APRO',
	dreamweaver: 'DRWV',
	muse: 'MUSE',
	animate: 'FLPR',
	'character-animator': 'CHAR',
	audition: 'AUDT',
	bridge: 'KBRG',
	'media-encoder': 'AME',
	incopy: 'AICY',
	prelude: 'PRLD',
	fuse: 'FUSE',
	'creative-cloud': 'KCCC',
	'fresco-desktop' : 'FRSC',
	'substance3d-painter': 'SBSTP',
	'substance-alchemist': 'SBSTA',
	'substance3d-designer': 'SBSTD',
	'substance3d-stager': 'STGR',
	'substance3d-community-assets': 'FFC_sbstshare',
	aero: 'AERO',
	'photoshop-express-desktop': 'PSXUWP',
	'behance-web': 'FFC_behance',
	'lightroom-web': 'FFC_lightroomweb',
	'express-mobile': 'FFC_ccxpost',
	'express-web': 'FFC_ccexpress',
	'portfolio-web': 'FFC_portfolio',
	'color-web': 'FFC_color',
	'spark-web': 'FFC-SPRK',
	'stock-web': 'FFC_stock',
	'adobe-fonts': 'FFC_fonts',
	'adobe-live-web': 'FFC_live',
	capture: 'FFC_capture',
	'lightroom-mobile': 'FFC_lightroom',
	'cc-mobile': 'FFC_ccmob',
	'xd-mobile': 'FFC_xd',
	'scan-mobile': 'FFC_scan',
	'acrobat-mobile': 'FFC_acrobat',
	'photoshop-sketch': 'FFC_sketch',
	'illustrator-draw': 'FFC_draw',
	'behance-mobile': 'FFC_mbehance',
	'spark-page-mobile': 'FFC_sppage',
	'spark-video-mobile': 'FFC_spvideo',
	'photoshop-express': 'FFC_psexp',
	'spark-post-mobile': 'FFC_sppost',
	'photoshop-fix': 'FFC_psfix',
	'rush-mobile': 'FFC_rush',
	'premiere-express-mobile': 'FFC_prexpr',
	comp: 'FFC_comp',
	'photoshop-mix': 'FFC_psmix',
	fresco: 'FFC_fresco' ,
	'substance-web': 'FFC_sbstsource',
	'mixamo-web': 'FFC_mixamo',
	'aero-mobile': 'FFC_aero',
	'photoshop-mobile': 'FFC_photoshop',
	'fill-sign': 'FFC_fillsign',
	'dc-web': 'FFC_dcweb',
	'sign-web': 'FFC_sign',
	'illustrator-mobile': 'FFC_illustrator',
	'photoshop-camera-mobile': 'FFC_phylo'
};

export const appCodeToJILWebAppName = {
	'behance-web': 'behance',
	FFC_behance: 'behance',
	'lightroom-web': 'lightroom_cc',
	FFC_lightroomweb: 'lightroom_cc',
	'portfolio-web': 'portfolio',
	FFC_portfolio: 'portfolio',
	'spark-web': 'spark',
	'FFC-SPRK': 'spark',
	'adobe-fonts': 'typekit',
	FFC_fonts: 'typekit',
	'stock-web': 'stock_image',
	FFC_stock: 'stock_image',
	'color-web': 'color',
	FFC_live: ''
};

/* eslint-enable camelcase */

export const CVSLocaleMap = {
	cs: 'cz/cs',
	da: 'dk/da',
	de: 'de/de',
	en: 'us/en',
	es: 'es/es',
	fi: 'fi/fi',
	fr: 'fr/fr',
	it: 'it/it',
	ja: 'jp/ja',
	ko: 'kr/ko',
	nb: 'no/no',
	nl: 'nl/nl',
	pl: 'pl/pl',
	pt: 'pt/pt',
	ru: 'ru/ru',
	sv: 'se/sv',
	tr: 'tr/tr',
	'zh-Hans': 'cn/zh-Hans',
	'zh-Hant': 'tw/zh-Hant'
};

export const CVSPreviewLocaleMap = {
	cs: 'langmaster/cs',
	da: 'langmaster/da',
	de: 'langmaster/de',
	en: 'langmaster/en',
	es: 'langmaster/es',
	fi: 'langmaster/fi',
	fr: 'langmaster/fr',
	it: 'langmaster/it',
	ja: 'langmaster/ja',
	ko: 'langmaster/ko',
	nb: 'langmaster/no',
	nl: 'langmaster/nl',
	pl: 'langmaster/pl',
	pt: 'langmaster/pt',
	ru: 'langmaster/ru',
	sv: 'langmaster/sv',
	tr: 'langmaster/tr',
	'zh-Hans': 'langmaster/zh_cn',
	'zh-Hant': 'langmaster/zh_tw'
};

export const CVSContentfulLocaleMap = {
	cs: 'cs-CZ',
	da: 'da-DK',
	de: 'de-DE',
	en: 'en-US',
	es: 'es-ES',
	fi: 'fi-FI',
	fr: 'fr-FR',
	it: 'it-IT',
	ja: 'ja-JP',
	ko: 'ko-KR',
	nb: 'nb-NO',
	nl: 'nl-NL',
	pl: 'pl-PL',
	pt: 'pt-BR',
	ru: 'ru-RU',
	sv: 'sv-SE',
	tr: 'tr-TR',
	'zh-Hans': 'zh-Hans-CN',
	'zh-Hant': 'zh-Hant-TW'
};

export const CCHToAEMLocaleMap = {
	cs: 'cs_CZ',
	da: 'da_DK',
	de: 'de_DE',
	en: 'en_US',
	es: 'es_ES',
	fi: 'fi_FI',
	fr: 'fr_FR',
	it: 'it_IT',
	ja: 'ja_JP',
	ko: 'ko_KR',
	nb: 'nb_NO',
	nl: 'nl_NL',
	pl: 'pl_PL',
	pt: 'pt_BR',
	ru: 'ru_RU',
	sv: 'sv_SE',
	tr: 'tr_TR',
	'zh-Hans': 'zh_CN',
	'zh-Hant': 'zh_TW'
};

export const FFCLocaleMap = {
	cs: 'cs_CZ',
	da: 'da_DK',
	de: 'de_DE',
	en: 'en_US',
	es: 'es_ES',
	fi: 'fi_FI',
	fr: 'fr_FR',
	it: 'it_IT',
	ja: 'ja_JP',
	ko: 'ko_KR',
	nb: 'nb_NO',
	nl: 'nl_NL',
	pl: 'pl_PL',
	pt: 'pt_BR',
	ru: 'ru_RU',
	sv: 'sv_SE',
	tr: 'tr_TR',
	'zh-Hans': 'zh_CN',
	'zh-Hant': 'zh_TW'
};

export const SophiaLocaleMap = {
	cs: 'cs_CZ',
	da: 'da_DK',
	de: 'de_DE',
	en: 'en_US',
	es: 'es_ES',
	fi: 'fi_FI',
	fr: 'fr_FR',
	it: 'it_IT',
	ja: 'ja_JP',
	ko: 'ko_KR',
	nb: 'nb_NO',
	nl: 'nl_NL',
	pl: 'pl_PL',
	pt: 'pt_BR',
	ru: 'ru_RU',
	sv: 'sv_SE',
	tr: 'tr_TR',
	'zh-Hans': 'zh_CN',
	'zh-Hant': 'zh_TW'
};

export const defaultTab = 'your-apps';
export const allTab = 'all';

export const additionalDownloadMessageData = {
	AEFT: {
		messageId: 'apps.download.amemessage',
		additionalProductsList: ['media-encoder']
	},
	FLPR: {
		messageId: 'apps.download.amemessage',
		additionalProductsList: ['media-encoder']
	},
	PRLD: {
		messageId: 'apps.download.amemessage',
		additionalProductsList: ['media-encoder']
	},
	PPRO: {
		messageId: 'apps.download.amemessage',
		additionalProductsList: ['media-encoder']
	},
	PPRONew: {
		messageId: 'apps.download.ame_rush_message',
		additionalProductsList: ['media-encoder', 'premiere-rush']
	},
	CHAR: {
		messageId: 'apps.download.amemessage',
		additionalProductsList: ['media-encoder']
	}
};

export const actionIds = {
	install: 'install',
	try: 'try',
	buy: 'buy',
	learnMore: 'learn-more',
	learnMorePDP: 'learn-more-pdp',
	download: 'download',
	notCompatible: 'not-compatible',
	enterprise: 'enterprise',
	installOldVersion: 'install-old-version',
	downloadOldVersion: 'download-old-version',
	tryOldVersion: 'try-old-version',
	launch: 'launch',
	startTrial: 'start-trial',
	sendLink: 'send-link',
	launchMobile: 'launch-mobile',
};

// A map between actionIds of CTAs and
// their event.subtype
export const actionBarSubtype = {
	install: 'install',
	try: 'try',
	buy: 'buy',
	buyNow: 'buy-now',
	'learn-more': 'learn-more',
	learnMore: 'learn-more',
	'learn-more-pdp': 'learn-more',
	download: 'download',
	'not-compatible': 'not-compatible',
	notCompatible: 'not-compatible',
	enterprise: 'enterprise',
	uninstall: 'uninstall',
	open: 'open',
	update: 'update',
	retry: 'retry',
	listOtherVersions: 'list-other-versions',
	launch: 'launch',
	'try-old-version': 'try-old-version',
	'install-old-version': 'install-old-version',
	'download-old-version': 'download-old-version',
	startTrial: 'start-trial',
	'start-trial': 'start-trial',
	progressCancel: 'cancel',
	cancel: 'cancel',
	'send-link': 'send-link',
	continue: 'continue',
	done: 'done',
	'keep-preferences': 'keep-preferences',
	'remove-preferences': 'remove-preferences',
	back: 'back',
	'launch-mobile': 'get',
	appTileSelect: 'app',
	errorInfo: 'more-info',
	seeMore: 'see-more',
	launchService: 'launch-service',
	getLink: 'get-link'
};

export const buttonData = {
	'try-old-version': {
		buttonText: 'apps.tile.tryOldVersion',
		buttonName: 'Try Old Version',
		ctaType: 'primary',
		linkURLType: 'callback',
		linkURL: '/content/cvs/us/en/cta-targets/try-old-version'
	},
	'download-old-version': {
		buttonText: 'apps.tile.downloadOldVersion',
		buttonName: 'Download Old Version',
		ctaType: 'primary',
		linkURLType: 'callback',
		linkURL: '/content/cvs/us/en/cta-targets/download-old-version'
	},
	'install-old-version': {
		buttonText: 'apps.tile.installOldVersion',
		buttonName: 'Install Older Version',
		ctaType: 'primary',
		linkURLType: 'callback',
		linkURL: '/content/cvs/us/en/cta-targets/install-old-version'
	},
	enterprise: {
		buttonText: 'apps.tile.enterprise',
		buttonName: 'Permission may be required',
		ctaType: 'primary',
		linkURLType: 'callback',
		linkURL: '/content/cvs/us/en/cta-targets/enterprise'
	},
	'not-compatible': {
		buttonText: 'apps.tile.notCompatible',
		buttonName: 'Not Compatible',
		ctaType: 'primary',
		linkURLType: 'callback',
		linkURL: '/content/cvs/us/en/cta-targets/not-compatible'
	},
	'learn-more-pdp': {
		buttonText: 'apps.tile.learnmore',
		buttonName: 'learn more',
		ctaType: 'primary',
		linkURLType: 'callback',
		linkURL: '/content/cvs/us/en/cta-targets/learn-more-pdp'
	},
	'learn-more': {
		buttonText: 'apps.tile.learnmore',
		buttonName: 'learn more',
		ctaType: 'primary',
		linkURLType: 'callback',
		linkURL: '/content/cvs/us/en/cta-targets/learn-more'
	},
	try: {
		buttonText: 'apps.tile.try',
		buttonName: 'try',
		ctaType: 'primary',
		linkURLType: 'callback',
		linkURL: '/content/cvs/us/en/cta-targets/try'
	},
	buy: {
		buttonText: 'apps.tile.buy',
		buttonName: 'buy',
		ctaType: 'cta',
		linkURLType: 'gourl',
		linkURL: 'https://www.adobe.com/go/cchome_buy_'
	},
	download: {
		buttonText: 'apps.tile.download',
		buttonName: 'download',
		ctaType: 'cta',
		linkURLType: 'callback',
		linkURL: '/content/cvs/us/en/cta-targets/download'
	},
	install: {
		buttonText: 'apps.tile.install',
		buttonName: 'install',
		ctaType: 'cta',
		linkURLType: 'callback',
		linkURL: '/content/cvs/us/en/cta-targets/install'
	},
	ios: {
		buttonText: 'apps.tile.ios',
		buttonName: 'ios',
		ctaType: 'cta',
		linkURLType: 'gourl',
		linkURL: 'https://www.adobe.com/go/cchome_ios_'
	},
	android: {
		buttonText: 'apps.tile.android',
		buttonName: 'android',
		ctaType: 'cta',
		linkURLType: 'gourl',
		linkURL: 'https://www.adobe.com/go/cchome_android_'
	},
	windows: {
		buttonText: 'apps.tile.windows',
		buttonName: 'windows',
		ctaType: 'cta',
		linkURLType: 'gourl',
		linkURL: 'https://www.adobe.com/go/cchome_windows_'
	},
	launch: {
		buttonText: 'apps.tile.launch',
		buttonName: 'launch',
		ctaType: 'cta',
		linkURLType: 'gourl',
		linkURL: 'https://www.adobe.com/go/cchome_launch_'
	},
	'launch-mobile': {
		buttonText: 'apps.tile.launch',
		buttonName: 'launch',
		ctaType: 'cta',
		linkURLType: 'gourl',
		linkURL: 'https://www.adobe.com/go/cchome_launch_'
	},
	'send-link': {
		buttonText: 'apps.tile.sendlink',
		buttonName: 'send-link',
		ctaType: 'cta',
		linkURLType: 'callback',
		linkURL: 'https://www.adobe.com/go/cchome_launch_'
	}
};

export const appButtonConfig = {
	PHSP: {
		inPlan: {
			pdp: ['install', 'download'],
			tile: ['learn-more', 'install', 'download']
		},
		notInPlan: {
			pdp: ['try', 'buy'],
			tile: ['learn-more', 'try', 'buy']
		}
	},
	RUSH: {
		inPlan: {
			pdp: ['install', 'download'],
			tile: ['learn-more', 'install', 'download']
		},
		notInPlan: {
			pdp: ['try', 'buy'],
			tile: ['learn-more', 'try', 'buy']
		}
	},
	ILST: {
		inPlan: {
			pdp: ['install', 'download'],
			tile: ['learn-more', 'install', 'download']
		},
		notInPlan: {
			pdp: ['try', 'buy'],
			tile: ['learn-more', 'try', 'buy']
		}
	},
	IDSN: {
		inPlan: {
			pdp: ['install', 'download'],
			tile: ['learn-more', 'install', 'download']
		},
		notInPlan: {
			pdp: ['try', 'buy'],
			tile: ['learn-more', 'try', 'buy']
		}
	},
	PPRO: {
		inPlan: {
			pdp: ['install', 'download'],
			tile: ['learn-more', 'install', 'download']
		},
		notInPlan: {
			pdp: ['try', 'buy'],
			tile: ['learn-more', 'try', 'buy']
		}
	},
	AEFT: {
		inPlan: {
			pdp: ['install', 'download'],
			tile: ['learn-more', 'install', 'download']
		},
		notInPlan: {
			pdp: ['try', 'buy'],
			tile: ['learn-more', 'try', 'buy']
		}
	},
	SPRK: {
		inPlan: {
			pdp: ['install', 'download'],
			tile: ['learn-more', 'install', 'download']
		},
		notInPlan: {
			pdp: ['try', 'buy'],
			tile: ['learn-more', 'try', 'buy']
		}
	},
	LRCC: {
		inPlan: {
			pdp: ['install', 'download'],
			tile: ['learn-more', 'install', 'download']
		},
		notInPlan: {
			pdp: ['try', 'buy'],
			tile: ['learn-more', 'try', 'buy']
		}
	},
	ESHR: {
		inPlan: {
			pdp: ['install', 'download'],
			tile: ['learn-more', 'install', 'download']
		},
		notInPlan: {
			pdp: ['try', 'buy'],
			tile: ['learn-more', 'try', 'buy']
		}
	},
	DRWV: {
		inPlan: {
			pdp: ['install', 'download'],
			tile: ['learn-more', 'install', 'download']
		},
		notInPlan: {
			pdp: ['try', 'buy'],
			tile: ['learn-more', 'try', 'buy']
		}
	},
	MUSE: {
		inPlan: {
			pdp: ['install', 'download'],
			tile: ['learn-more', 'install', 'download']
		},
		notInPlan: {
			pdp: ['try', 'buy'],
			tile: ['learn-more', 'try', 'buy']
		}
	},
	CHAR: {
		inPlan: {
			pdp: ['install', 'download'],
			tile: ['learn-more', 'install', 'download']
		},
		notInPlan: {
			pdp: ['try'],
			tile: ['learn-more', 'try']
		}
	},
	KBRG: {
		inPlan: {
			pdp: ['install', 'download'],
			tile: ['learn-more', 'install', 'download']
		},
		notInPlan: {
			pdp: ['try', 'buy'],
			tile: ['learn-more', 'try', 'buy']
		}
	},
	FLPR: {
		inPlan: {
			pdp: ['install', 'download'],
			tile: ['learn-more', 'install', 'download']
		},
		notInPlan: {
			pdp: ['try', 'buy'],
			tile: ['learn-more', 'try', 'buy']
		}
	},
	AICY: {
		inPlan: {
			pdp: ['install', 'download'],
			tile: ['learn-more', 'install', 'download']
		},
		notInPlan: {
			pdp: ['try', 'buy'],
			tile: ['learn-more', 'try', 'buy']
		}
	},
	AUDT: {
		inPlan: {
			pdp: ['install', 'download'],
			tile: ['learn-more', 'install', 'download']
		},
		notInPlan: {
			pdp: ['try', 'buy'],
			tile: ['learn-more', 'try', 'buy']
		}
	},
	FUSE: {
		inPlan: {
			pdp: ['install', 'download'],
			tile: ['learn-more', 'install', 'download']
		},
		notInPlan: {
			pdp: ['try'],
			tile: ['learn-more', 'try']
		}
	},
	LTRM: {
		inPlan: {
			pdp: ['install', 'download'],
			tile: ['learn-more', 'install', 'download']
		},
		notInPlan: {
			pdp: ['try', 'buy'],
			tile: ['learn-more', 'try', 'buy']
		}
	},
	AME: {
		inPlan: {
			pdp: ['install', 'download'],
			tile: ['learn-more', 'install', 'download']
		},
		notInPlan: {
			pdp: ['try'],
			tile: ['learn-more', 'try']
		}
	},
	PRLD: {
		inPlan: {
			pdp: ['install', 'download'],
			tile: ['learn-more', 'install', 'download']
		},
		notInPlan: {
			pdp: ['try'],
			tile: ['learn-more', 'try']
		}
	},
	APRO: {
		inPlan: {
			pdp: ['install', 'download'],
			tile: ['learn-more', 'install', 'download']
		},
		notInPlan: {
			pdp: ['try', 'buy'],
			tile: ['learn-more', 'try', 'buy']
		}
	},
	PSXUWP: {
		inPlan: {
			pdp: ['install', 'download'],
			tile: ['learn-more', 'install', 'download']
		},
		notInPlan: {
			pdp: ['try', 'buy'],
			tile: ['learn-more', 'try', 'buy']
		}
	},
	KCCC: {
		inPlan: {
			pdp: ['install', 'download'],
			tile: ['learn-more', 'install', 'download']
		},
		notInPlan: {
			pdp: ['try', 'buy'],
			tile: ['learn-more', 'try', 'buy']
		}
	},
	FRSC: {
		inPlan: {
			pdp: ['install', 'download'],
			tile: ['learn-more', 'install', 'download']
		},
		notInPlan: {
			pdp: ['try', 'buy'],
			tile: ['learn-more', 'try', 'buy']
		}
	},
	SBSTP: {
		inPlan: {
			pdp: ['install', 'download'],
			tile: ['learn-more', 'install', 'download']
		},
		notInPlan: {
			pdp: ['try', 'buy'],
			tile: ['learn-more', 'try', 'buy']
		}
	},
	SBSTA: {
		inPlan: {
			pdp: ['install', 'download'],
			tile: ['learn-more', 'install', 'download']
		},
		notInPlan: {
			pdp: ['try', 'buy'],
			tile: ['learn-more', 'try', 'buy']
		}
	},
	SBSTD: {
		inPlan: {
			pdp: ['install', 'download'],
			tile: ['learn-more', 'install', 'download']
		},
		notInPlan: {
			pdp: ['try', 'buy'],
			tile: ['learn-more', 'try', 'buy']
		}
	},
	STGR: {
		inPlan: {
			pdp: ['install', 'download'],
			tile: ['learn-more', 'install', 'download']
		},
		notInPlan: {
			pdp: ['try', 'buy'],
			tile: ['learn-more', 'try', 'buy']
		}
	},
	AERO: {
		inPlan: {
			pdp: ['install', 'download'],
			tile: ['learn-more', 'install', 'download']
		},
		notInPlan: {
			pdp: ['try'],
			tile: ['learn-more', 'try']
		}
	},
	'spark-web': {
		inPlan: {
			pdp: ['launch'],
			tile: ['learn-more', 'launch']
		},
		notInPlan: {
			pdp: ['launch'],
			tile: ['learn-more', 'launch']
		}
	},
	'behance-web': {
		inPlan: {
			pdp: ['launch'],
			tile: ['learn-more', 'launch']
		},
		notInPlan: {
			pdp: ['launch'],
			tile: ['learn-more', 'launch']
		}
	},
	'adobe-fonts': {
		inPlan: {
			pdp: ['launch'],
			tile: ['learn-more', 'launch']
		},
		notInPlan: {
			pdp: ['launch'],
			tile: ['learn-more', 'launch']
		}
	},
	'stock-web': {
		inPlan: {
			pdp: ['launch'],
			tile: ['learn-more', 'launch']
		},
		notInPlan: {
			pdp: ['launch'],
			tile: ['learn-more', 'launch']
		}
	},
	'lightroom-web': {
		inPlan: {
			pdp: ['launch'],
			tile: ['learn-more', 'launch']
		},
		notInPlan: {
			pdp: ['launch'],
			tile: ['learn-more', 'launch']
		}
	},
	'portfolio-web': {
		inPlan: {
			pdp: ['launch'],
			tile: ['learn-more', 'launch']
		},
		notInPlan: {
			pdp: ['launch'],
			tile: ['learn-more', 'launch']
		}
	},
	'lightroom-mobile': {
		inPlan: {
			pdp: ['ios', 'android'],
			tile: ['learn-more', 'ios', 'android']
		},
		notInPlan: {
			pdp: ['ios', 'android'],
			tile: ['learn-more', 'ios', 'android']
		}
	},
	'cc-mobile': {
		inPlan: {
			pdp: ['ios', 'android'],
			tile: ['learn-more', 'ios', 'android']
		},
		notInPlan: {
			pdp: ['ios', 'android'],
			tile: ['learn-more', 'ios', 'android']
		}
	},
	'photoshop-express': {
		inPlan: {
			pdp: ['ios', 'android', 'windows'],
			tile: ['learn-more', 'ios', 'android', 'windows']
		},
		notInPlan: {
			pdp: ['ios', 'android', 'windows'],
			tile: ['learn-more', 'ios', 'android', 'windows']
		}
	},
	'photoshop-fix': {
		inPlan: {
			pdp: ['ios', 'android'],
			tile: ['learn-more', 'ios', 'android']
		},
		notInPlan: {
			pdp: ['ios', 'android'],
			tile: ['learn-more', 'ios', 'android']
		}
	},
	'photoshop-mix': {
		inPlan: {
			pdp: ['ios', 'android'],
			tile: ['learn-more', 'ios', 'android']
		},
		notInPlan: {
			pdp: ['ios', 'android'],
			tile: ['learn-more', 'ios', 'android']
		}
	},
	'photoshop-sketch': {
		inPlan: {
			pdp: ['ios', 'android'],
			tile: ['learn-more', 'ios', 'android']
		},
		notInPlan: {
			pdp: ['ios', 'android'],
			tile: ['learn-more', 'ios', 'android']
		}
	},
	'spark-post-mobile': {
		inPlan: {
			pdp: ['ios'],
			tile: ['learn-more', 'ios']
		},
		notInPlan: {
			pdp: ['ios'],
			tile: ['learn-more', 'ios']
		}
	},
	'spark-page-mobile': {
		inPlan: {
			pdp: ['ios'],
			tile: ['learn-more', 'ios']
		},
		notInPlan: {
			pdp: ['ios'],
			tile: ['learn-more', 'ios']
		}
	},
	'behance-mobile': {
		inPlan: {
			pdp: ['ios', 'android'],
			tile: ['learn-more', 'ios', 'android']
		},
		notInPlan: {
			pdp: ['ios', 'android'],
			tile: ['learn-more', 'ios', 'android']
		}
	},
	'behance-display-mobile': {
		inPlan: {
			pdp: ['ios', 'android'],
			tile: ['learn-more', 'ios', 'android']
		},
		notInPlan: {
			pdp: ['ios', 'android'],
			tile: ['learn-more', 'ios', 'android']
		}
	},
	capture: {
		inPlan: {
			pdp: ['ios', 'android'],
			tile: ['learn-more', 'ios', 'android']
		},
		notInPlan: {
			pdp: ['ios', 'android'],
			tile: ['learn-more', 'ios', 'android']
		}
	},
	comp: {
		inPlan: {
			pdp: ['ios', 'android'],
			tile: ['learn-more', 'ios', 'android']
		},
		notInPlan: {
			pdp: ['ios', 'android'],
			tile: ['learn-more', 'ios', 'android']
		}
	},
	'illustrator-draw': {
		inPlan: {
			pdp: ['ios', 'android'],
			tile: ['learn-more', 'ios', 'android']
		},
		notInPlan: {
			pdp: ['ios', 'android'],
			tile: ['learn-more', 'ios', 'android']
		}
	},
	'premiere-clip': {
		inPlan: {
			pdp: ['ios', 'android'],
			tile: ['learn-more', 'ios', 'android']
		},
		notInPlan: {
			pdp: ['ios', 'android'],
			tile: ['learn-more', 'ios', 'android']
		}
	},
	'spark-video-mobile': {
		inPlan: {
			pdp: ['ios'],
			tile: ['learn-more', 'ios']
		},
		notInPlan: {
			pdp: ['ios'],
			tile: ['learn-more', 'ios']
		}
	},
	'xd-mobile': {
		inPlan: {
			pdp: ['ios', 'android'],
			tile: ['learn-more', 'ios', 'android']
		},
		notInPlan: {
			pdp: ['ios', 'android'],
			tile: ['learn-more', 'ios', 'android']
		}
	},
	'premiere-rush-mobile': {
		inPlan: {
			pdp: ['ios', 'android'],
			tile: ['learn-more', 'ios', 'android']
		},
		notInPlan: {
			pdp: ['ios', 'android'],
			tile: ['learn-more', 'ios', 'android']
		}
	},
	mobile : {
		inPlan: {
			pdp: ['send-link', 'launch-mobile'],
			tile: ['learn-more', 'send-link', 'launch-mobile']
		},
		notInPlan: {
			pdp: ['send-link', 'launch-mobile'],
			tile: ['learn-more', 'send-link', 'launch-mobile']
		}
	},
	web : {
		inPlan: {
			pdp: ['launch'],
			tile: ['learn-more', 'launch']
		},
		notInPlan: {
			pdp: ['launch'],
			tile: ['learn-more', 'launch']
		}
	}
};

export const PDPErrorTypes = {
	PDPEndpointDown: {
		errorId: 'pdp-cvs-enpoint-down',
		messageId: 'apps.pdp.notLoadingError'
	},
	AppNotInFFC: {
		errorId: 'app-not-in-ffc-data',
		messageId: 'apps.pdp.noFFCDataError'
	}
};

export const goUrlBaseLink = 'https://www.adobe.com/go/';

export const planProductsMap = {
	'all-apps': {
		primaryProductId: 'photoshop',
		primaryProductSapCode: 'PHSP'
	},
	ccpp: {
		primaryProductId: 'lightroom',
		primaryProductSapCode: 'LRCC',
		secondaryProductId: 'lightroom-classic',
		secondaryProductSapCode: 'LTRM'
	},
	ccppn: {
		primaryProductId: 'lightroom',
		primaryProductSapCode: 'LRCC',
		secondaryProductId: 'lightroom-classic',
		secondaryProductSapCode: 'LTRM'
	},
	lccp: {
		primaryProductId: 'lightroom',
		primaryProductSapCode: 'LRCC'
	},
	'substance3d-collection': {
		primaryProductId: 'substance-alchemist',
		primaryProductSapCode: 'SBSTA'
	},
	'substance3d-texturing': {
		primaryProductId: 'substance-alchemist',
		primaryProductSapCode: 'SBSTA'
	},
};

export const desktopApps = Object.values(sapCodeToProductMetaData).filter(productObj => productObj.platform === 'desktop')
	.map(productObj => productObj.productId);

/* List of desktop products that have a corresponding single app plans */
export const singleAppPlans = [
	'incopy',
	'audition',
	'dimension',
	'dreamweaver',
	'animate',
	'lightroom',
	'aftereffects',
	'indesign',
	'premiere-rush',
	'premiere',
	'acrobat',
	'photoshop',
	'illustrator',
	'xd'
];

export const nujM3SingleAppPlansJDI = [
	'incopy',
	'audition',
	'dimension',
	'dreamweaver',
	'animate',
	'premiere-rush',
	'acrobat',
	'xd'
];

export const customerSegmentValues = {
	INDIVIDUAL : 'INDIVIDUAL',
	TEAM: 'TEAM',
	ENTERPRISE: 'ENTERPRISE'
};

export const pageRefreshOnThorDetect = {
	interval : 5000,
	iterations: 180, // iterations = minutes * 60 * 1000 / interval; default 15 minutes
	nextIterations: 720,
	nextIterationsOneDay: 17280
};

export const installationTab = 'installation';
export const starterTab = 'starter';

export const subHeadingFilter = {
	trailApps: 'trial',
	updatableApps: 'new-updates',
	recentlyUpdated: 'recent-updates',
	installedApps: 'installed',
	installApps: 'install',
	subscribed: 'subscribed',
	freemium: 'freemium',
	updatedRecently: 'updated-recently'
};

export const pdpActionIds = {
	languages: 'languages',
	compatibility: 'compatibility'
};

export const ffcPath = {
	core: '/adobe-ffc-external/core',
	sms: '/adobe-ffc-external/core/v1/mobileapps/sms',
	email: '/adobe-ffc-external/core/v1/mobileapps/email',
	emailDesktop: '/adobe-ffc-external/core/v1/sendlink/email'
};

export const appPickerFeedbackType = {
	SKIPPED_GUIDED: 'skippedGuided',
	AUTO_DOWNLOAD: 'autoDownload',
	AUTO_DOWNLOAD_NO_CLICK: 'autoDownloadNoClick',
	AUTO_DOWNLOAD_CANCEL: 'autoDownloadCancel',
	DISABLED_CCLOGO_CLICK: 'disabledCCLogoClick',
	DISABLED_ADOBE_CLICK: 'disabledAdobeClick',
	CLOSED: 'closed'
};

export const appPickerFeedbackAnalyticConstants = {
	[appPickerFeedbackType.SKIPPED_GUIDED]: {
		contentName: 'Help us improve our guided experience',
		uiFilter: 'Guide Me Skip Feedback',
		contentType: 'help-me-choose-skip'
	},
	[appPickerFeedbackType.AUTO_DOWNLOAD]: {
		contentName: 'Did you have trouble choosing an app',
		uiFilter: 'Auto Download Yes Feedback',
		contentType: 'auto-download-first-app'
	},
	[appPickerFeedbackType.AUTO_DOWNLOAD_CANCEL]: {
		contentName: 'What would you like to do',
		uiFilter: 'Auto Download Cancel Feedback',
		contentType: 'auto-download-cancel'
	},
	[appPickerFeedbackType.DISABLED_CCLOGO_CLICK]: {
		contentName: 'Can we help you find something',
		uiFilter: 'CC Logo Feedback',
		contentType: 'cc-logo'
	},
	[appPickerFeedbackType.DISABLED_ADOBE_CLICK]: {
		contentName: 'Can we help you find something',
		uiFilter: 'Adobe Logo Feedback',
		contentType: 'adobe-logo'
	},
	[appPickerFeedbackType.AUTO_DOWNLOAD_NO_CLICK]: {
		contentName: 'Did you have trouble choosing an app',
		uiFilter: 'Auto Download No Click Feedback',
		contentType: 'auto-download-no-click'
	}
};

export const eventSourceMap = {
	banner: 'banner',
	apps: 'app-tile',
	pdp: 'pdp'
};

export const companionMobileAppMap = {
	lightroom: 'FFC_lightroom',
	'lightroom-classic': 'FFC_lightroom',
	photoshop: {
		ipad: 'FFC_photoshop',
		iphone: 'FFC_psexp',
		android: 'FFC_psexp'
	},
	acrobat: 'FFC_acrobat',
	rush: 'FFC_rush',
	'premiere-rush': 'FFC_rush',
	premiere: 'FFC_rush',
	xd: 'FFC_xd',
	'fresco-desktop': 'FFC_fresco',
	illustrator: {
		ipad: 'FFC_illustrator',
		iphone: 'FFC_draw',
		android: 'FFC_draw'
	}
};

export const SOPHIA_SURFACE_ID = {
	allAppsBanners: 'ccw_all_apps_banners',
	appSkeleton: 'ACCC_APP_SKELETON',
	categoriesBanners: 'ccw_categories_banners',
	pdpCatalog: 'ccw_apps_catalog'
};

export type FFCProductCallObject = {
    channel: string,
    isCCD: boolean,
    headers: {
        withAuth: boolean,
        withAppId: boolean
    },
    config: {
        allVersion: boolean,
        sapCode?: string
    }
};

export const THOR_STATUS = {
	KAIZEN: 'kaizen',
	THOR: 'thor',
	WAM: 'wam'
};

export const eolProductInfo = {
	'spark-post-mobile': {
		displayName: 'Spark Post',
		errorTitle: 'Spark Post is not available',
		errorMessage: 'Try something else'
	},
	generic: {
		displayName: 'App',
		errorTitle: 'App is not available',
		errorMessage: 'Try something else'
	}
};